;(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)')

  const getPanel = (detail) => detail.querySelector('.zv-footer__accordion-panel')

  const finishOpening = (detail, panel) => {
    if (!detail.open) return
    panel.style.maxHeight = 'none'
    panel.style.opacity = '1'
  }

  const openAccordion = (detail, animate = true) => {
    const panel = getPanel(detail)
    if (!panel) return

    detail.open = true

    if (!animate) {
      panel.style.maxHeight = 'none'
      panel.style.opacity = '1'
      return
    }

    panel.style.maxHeight = '0px'
    panel.style.opacity = '0'

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.maxHeight = panel.scrollHeight + 'px'
        panel.style.opacity = '1'
      })
    })

    const onEnd = (event) => {
      if (event.propertyName !== 'max-height') return
      panel.removeEventListener('transitionend', onEnd)
      finishOpening(detail, panel)
    }
    panel.addEventListener('transitionend', onEnd)
  }

  const closeAccordion = (detail, animate = true) => {
    const panel = getPanel(detail)
    if (!panel) return

    if (!animate) {
      detail.open = false
      panel.style.maxHeight = '0px'
      panel.style.opacity = '0'
      return
    }

    panel.style.maxHeight = panel.scrollHeight + 'px'
    panel.style.opacity = '1'

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.maxHeight = '0px'
        panel.style.opacity = '0'
      })
    })

    const onEnd = (event) => {
      if (event.propertyName !== 'max-height') return
      panel.removeEventListener('transitionend', onEnd)
      detail.open = false
    }
    panel.addEventListener('transitionend', onEnd)
  }

  const resetForMode = (accordions, isMobile) => {
    accordions.forEach((detail) => {
      const panel = getPanel(detail)
      if (!panel) return

      detail.open = false
      panel.style.maxHeight = isMobile ? '0px' : ''
      panel.style.opacity = isMobile ? '0' : ''
    })
  }

  const initFooterAccordions = (root = document) => {
    const accordions = Array.from(root.querySelectorAll('.zv-footer__accordion'))
    if (!accordions.length) return

    accordions.forEach((detail) => {
      const summary = detail.querySelector('summary')
      if (!summary || detail.dataset.zvAccordionBound === 'true') return

      detail.dataset.zvAccordionBound = 'true'
      summary.addEventListener('click', (event) => {
        if (!mobileQuery.matches) return

        event.preventDefault()
        const shouldOpen = !detail.open

        accordions.forEach((other) => {
          if (other !== detail && other.open) closeAccordion(other)
        })

        if (shouldOpen) {
          openAccordion(detail)
        } else {
          closeAccordion(detail)
        }
      })
    })

    resetForMode(accordions, mobileQuery.matches)

    const onModeChange = (event) => {
      resetForMode(accordions, event.matches)
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onModeChange)
    } else {
      mobileQuery.addListener(onModeChange)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFooterAccordions(document), { once: true })
  } else {
    initFooterAccordions(document)
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFooterAccordions(event.target)
  })
})()
